import { Outlet } from 'react-router-dom';
import { ScheduleStateProvider } from 'domains/direct-schedule/useScheduleProvider';
import { DisplayTimezoneProvider } from 'domains/timezone/useDisplayTimezone';
import { DEFAULT_TIMEZONE_OPTION, detectTimeZone, timeZoneOptions } from 'domains/timezone';

export const ScheduleWrapper = () => {
  const localTimezone = detectTimeZone();
  const currentTimezone = timeZoneOptions.find(timezone => timezone.value === localTimezone) ?? DEFAULT_TIMEZONE_OPTION;

  return (
    <DisplayTimezoneProvider defaultTimezone={currentTimezone}>
      <ScheduleStateProvider>
        <Outlet />
      </ScheduleStateProvider>
    </DisplayTimezoneProvider>
  );
};
